export default {"src":"https://fishbrain.com/_next/static/media/newMexico.ebd142b6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};